import React, { Component, useState, useEffect, useCallback } from "react";
import { Icon, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

import {
  Container,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  LinkRedirect,
  SemanticButton,
  StatusToogleButton,
} from "./styled";

import { producaov2 as api } from "../../../../services/apis";

const PaginaListar = (props) => {
  const [emails, setEmails] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    listarEmails();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const listarEmails = async () => {
    try {
      const response = await api.get(`admin/emails`);
      let array = { local: "emails", texto: `listou os emails` };
      await api.post("system_logs", { acao: JSON.stringify(array) });
      setEmails(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar os emails", "", "error");
      setLoading(false);
    }
  };
  const removerEmails = useCallback(
    (id) => {
      swal("Remoção de Emails", "Você tem certeza que quer remover? ", "").then(
        (res) => {
          if (res) {
            api.delete(`admin/email/${id}`).then(async (res) => {
              let array = {
                local: "email",
                texto: `deletou o email de id=${id}`,
              };
              await api.post("system_logs", { acao: JSON.stringify(array) });
              const newEmails = [...emails].filter((email) => email.id !== id);
              setEmails(newEmails.reverse());
            });
          }
        }
      );
    },
    [emails]
  );

  return (
    <>
      <AdminMenu />

      <Container>
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>E-mails</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar email..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />
              <CreateButton to="/admin/emails/criar">Criar</CreateButton>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell> Id </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Título </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Ações </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {emails
                  .reverse()
                  .filter((email) =>
                    email.titulo.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((email, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell> {email.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>{email.titulo}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        <>
                          <LinkRedirect
                            to={`/admin/emails/detalhes/${email.id}`}
                          >
                            <SemanticButton
                              icon="edit icon"
                              info="edit"
                              onClick
                            />
                          </LinkRedirect>

                          <SemanticButton
                            icon="trash icon"
                            info="delete"
                            onClick={() => removerEmails(email.id)}
                          />
                        </>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};
export default PaginaListar;
